import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import './MobileButton.sass';

export const MobileButton = ({icon, title, onClick, active, dataQaId}) => (
  // biome-ignore lint/a11y/useFocusableInteractive: add accessibility props
  // biome-ignore lint/a11y/useKeyWithClickEvents: add accessibility props
  <div onClick={onClick} role="button">
    <Button
      id="navBottom"
      className={`card_editor__mobile__button ${
        active ? 'card_editor__mobile__button--active' : ''
      }`}
      variant="secondary"
      size="small"
      data-qa-id={dataQaId}
    >
      {icon}
    </Button>
    <Typography variant="paragraph3" className="card_editor__mobile__button__title">
      {title}
    </Typography>
  </div>
);
